import type { Idea } from 'common/api/endpoints/idea';

const getIdeaURL = (idea: Pick<Idea, 'urlName'>) => `/admin/ideas?idea=${idea.urlName}`;

export default getIdeaURL;
